import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPressPropertyList from './property_list';
import ReactPressPropertyDetail from './property_detail';

class ReactPressProperty extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <ReactPressPropertyList/>;
    }else{
      if(params.id===undefined){
        view = <ReactPressPropertyDetail/>;
      }else{
        view = <ReactPressPropertyDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

ReactPressProperty.contextTypes = {
  router: PropTypes.object
};

export default ReactPressProperty;
